import { createStyles, makeStyles } from "@material-ui/core/styles";
import { HEIGHT_HEADER } from "config/constant";

const useStyles = makeStyles(
	theme =>
		createStyles({
			rootHeader: {
				position: "sticky",
				zIndex: 1111
			},
			header: {
				display: "flex",
				height: HEIGHT_HEADER,
				justifyContent: "center",
				alignItems: "center",
				background: theme.palette.primary.main,
				paddingBottom: 100
			},
			btnBack: {
				marginRight: 10,
				cursor: "pointer",
				position: "absolute",
				left: 16,
				"& >svg": {
					fill: theme.palette.text.contrastText
				},
				"&:active": {
					opacity: 0.7
				}
			},
			titleHeader: {
				color: theme.palette.text.contrastText,
				fontSize: 18,
				fontWeight: 600
			},
			customAvatar: {
				display: "flex",
				justifyContent: "center",
				marginTop: -45,
				flexDirection: "column",
				background: theme.palette.common.white,
				alignItems: "center",
				borderRadius: "50px 50px 0px 0px"
			},
			avatar: {
				position: "relative",
				width: 90,
				height: 90,
				marginTop: -45,
				"& > img": {
					width: 90,
					height: 90,
					borderRadius: 50,
					border: `3px solid ${theme.palette.grey["A400"]}`,
					objectFit: "cover"
				}
			},
			textCamera: {
				fontSize: 14,
				color: theme.palette.primary.contrastText,
				marginTop: 10
			},
			root: {
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				background: theme.palette.common.white
			},
			title: {
				fontSize: 14,
				fontWeight: 500,
				color: theme.palette.secondary.contrastText,
				"& >span": {
					fontWeight: 400,
					fontStyle: "italic"
				}
			},
			customInput: {
				color: theme.palette.primary.contrastText,
				marginTop: 5,
				marginBottom: 15,
				"& > .MuiInput-root": {
					height: "inherit",
					border: "1px solid #c4c4c3",
					borderRadius: 6
				},
				height: "100%",
				width: "100%",
				"& > div > input": {
					color: theme.palette.primary.contrastText,
					height: 30,
					backgroundColor: theme.palette.grey["A100"],
					fontSize: 14,
					lineHeight: "21px",
					padding: "3px 10px",
					"@media only screen and (max-width: 768px)": {
						fontSize: 14,
						lineHeight: "19px"
					}
				},
				"& > div > textarea": {
					color: theme.palette.primary.contrastText,
					margin: 20,
					backgroundColor: theme.palette.grey["A100"]
				},
				"& > .MuiInput-underline:before": {
					borderBottom: `1px solid ${theme.palette.grey["A100"]}`,
					content: "none"
				},
				"& > .MuiInput-underline:after": {
					content: "none",
					borderBottom: `1px solid ${theme.palette.grey["A100"]}`
				},
				"& > div > .MuiSelect-select.MuiSelect-select": {
					color: theme.palette.primary.contrastText,
					textAlign: "initial",
					marginLeft: 15,
					height: 23,
					alignItems: "center",
					display: "flex"
				}
			},
			inputError: {
				border: `1px solid ${theme.palette.error.main} !important`,
				borderRadius: "6px !important"
			},
			rootForm: {
				padding: 15
			},
			bodyBtnSubmit: {
				display: "flex",
				justifyContent: "center",
				marginTop: 10
			},
			btnSubmit: {
				background: theme.palette.primary.main,
				color: theme.palette.text.contrastText,
				fontSize: 14,
				textTransform: "inherit",
				width: "100%",
				height: 36,
				borderRadius: 6,
				"&:active": {
					opacity: 0.7,
					background: theme.palette.primary.main
				},
				"&:hover": {
					opacity: 0.7,
					background: theme.palette.primary.main
				}
			},
			btnSubmitDisabled: {
				opacity: "0.7 !important",
				backgroundColor: `${theme.palette.primary.main} !important`
			},
			textError: {
				fontSize: 12,
				marginTop: 5,
				color: theme.palette.error.main
			},
			btnCamera: {
				position: "absolute",
				bottom: -10,
				right: 0,
				cursor: "pointer",
				"&:hover": {
					opacity: 0.7
				}
			},
			storeOwner: {
				display: "flex",
				alignItems: "center",
				fontSize: 14,
				color: theme.palette.secondary.main,
				fontWeight: 500,
				paddingBottom: 10,
				borderBottom: `1px dashed ${theme.palette.grey[800]}`,
				"& > img": {
					marginRight: 5
				},
				"& > span": {
					color: theme.palette.error.main
				}
			},
			warningBody: {
				display: "flex",
				padding: 10,
				border: `1px dashed ${theme.palette.primary.main}`,
				borderRadius: 6
			},
			iconWarning: {
				"& > img": {
					width: 18,
					height: 18
				}
			},
			textWarning: {
				lineHeight: "20px",
				fontSize: 14,
				fontStyle: "italic",
				"& > span": {
					marginLeft: 2,
					fontWeight: 500,
					color: theme.palette.primary.main
				}
			},
			btnDefaultCamera: {
				cursor: "pointer",
				height: "100%",
				width: "100%",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				flexDirection: "column",
				"&:active": {
					opacity: 0.7
				}
			},
			camera: {
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				flexDirection: "column",
				height: 110,
				background: theme.palette.grey["A400"],
				borderRadius: 8,
				position: "relative",
				"&>label": {
					fontSize: 14
				}
			},
			imageIdentityCard: {
				width: "100%",
				height: 110,
				objectFit: "cover",
				borderRadius: 8,
				border: `1px solid ${theme.palette.grey["A400"]}`
			},
			btnCloseImage: {
				position: "absolute",
				top: 0,
				right: 0,
				padding: 5,
				color: theme.palette.grey[900],
				zIndex: 999
			}
		}),
	{
		name: "InfomationStorePage",
		index: 1
	}
);

export default useStyles;
